// extracted by mini-css-extract-plugin
module.exports = {"greenIcon":"success_greenIcon__2uMpS","text":"success_text__84EZA"};